export default __webpack_public_path__ + "static/media/rings.2962d585.svg";